class PaginationItems {
  constructor(el, itemSelector, itemsPerClick = 8) {
    this.el = el;
    this.itemSelector = itemSelector;
    this.itemsPerClick = itemsPerClick;

    this.bindListeners();
  }

  bindListeners() {
    this.el.addEventListener("click", this.handleClick.bind(this));

    this.countUpdate();
  }

  handleClick() {
    const hiddenItems = document.querySelectorAll(`${this.itemSelector}.hide`);
    Array.from(hiddenItems).slice(0, this.itemsPerClick).forEach(item => {
      item.classList.add("show");
      item.classList.remove("hide");
    });

    const anyRemaining = Array.from(hiddenItems).some(item => item.classList.contains("hide"));

    if (!anyRemaining) {
      this.el.classList.add("hide");
    }

    this.countUpdate();
  }

  countUpdate() {
    const hiddenItems = document.querySelectorAll(`${this.itemSelector}.hide`);
    const digit = this.el.querySelector('.digit');
    if(digit) {
      digit.innerHTML = '[' + hiddenItems.length + ']';
    }
  }
}

function initPagination() {
  const configs = [
    {
      buttonSelector: ".team-grid__pagination--mobile .btn",
      itemSelector: ".accordion__item",
      itemsPerClick: 4
    },
    {
      buttonSelector: ".team-grid__pagination--desktop .btn",
      itemSelector: ".team-grid__content--desktop .team-grid__content-item",
      itemsPerClick: 4
    },
    {
      buttonSelector: ".team-grid__pagination--mid .btn",
      itemSelector: ".team-grid__content--mid .team-grid__content-item",
      itemsPerClick: 3
    }
  ];

  configs.forEach(({ buttonSelector, itemSelector, itemsPerClick }) => {
    const button = document.querySelector(buttonSelector);
    if (button) {
      new PaginationItems(button, itemSelector, itemsPerClick);
    }
  });
}

initPagination();
